import script from "./ModalStartTimeError.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalStartTimeError.vue?vue&type=script&setup=true&lang=ts"

import "./ModalStartTimeError.vue?vue&type=style&index=0&id=6a0ab548&lang=scss"

const __exports__ = script;

export default __exports__